const dashboardFR = {
    "view": {
        "label": {
            "allTimeSales": "Ventes Totales",
            "totalToBePaid": "Total à Payer",
            "promoCoins": "Pièces Promo",
            "promoDownloadCount": "Nombre de Téléchargements Promo",
            "promoFeedbackCount": "Nombre de Retours Promo",
            "totalDownloads": "Total des Téléchargements",
            "totalFeedbacks": "Total des Retours"
        },
        "options": {
            "earnings": {
                "allTime": "Revenus Totals",
                "last12Months": "12 Derniers Mois"
            },
            "months": {
                "jan": "Jan",
                "feb": "Fév",
                "mar": "Mar",
                "apr": "Avr",
                "may": "Mai",
                "jun": "Juin",
                "jul": "Juil",
                "aug": "Aoû",
                "sep": "Sep",
                "oct": "Oct",
                "nov": "Nov",
                "dec": "Déc"
            }
        },
        "message": {
            "userWelcomeTitle": "Salut {{firstName}}, bienvenue de retour sur la plateforme Music Link.",
            "ownedAndManaged": "Votre compte est détenu et géré par <1>{{ parent_company }}</1>, visitez notre <3>Page d'Aide</3> pour en savoir plus.",
            "completeInformation": "Vous n'avez pas encore soumis vos informations, veuillez <1><strong>Compléter Vos Informations</strong></1> pour continuer !",
            "notSubscribed": "Vous n'êtes abonné à aucun plan. Abonnez-vous maintenant pour libérer tout le potentiel de la plateforme Music Link !",
            "accountBlacklisted": "Votre compte a été blacklisté après examen car nous avons constaté que les informations associées à votre compte sont liées à un utilisateur internationalement blacklisté dans notre système. Par conséquent, nous avons désactivé la fonctionnalité de distribution pour votre compte.",
        }
    }
};

export default dashboardFR;